import React from "react";

interface IProps {
  message: string;
}

function LoginMessageDisplay({ message }: IProps) {
  if (!message) {
    return <></>;
  }
  return (
    <div className="alert alert-info py-2 mb-3" role="status">
      {message}
    </div>
  );
}

export default LoginMessageDisplay;
